module.exports = __webpack_public_path__ + "img/male.5097b024.jpg";